export const Textarea = ({
  value,
  onChange,
  label,
  required,
  error,
  placeholder,
  labelClassName = "textarea-label",
  className = "textarea-proper",
}) => {
  return (
    <section className="textarea-main">
      {label && (
        <label className={labelClassName} htmlFor={label}>
          {label}
          <span>{required ? "Required" : ""}</span>
        </label>
      )}
      <textarea
        id={label}
        name={label}
        className={`${className === "" ? "textarea-proper" : className} ${error ? "error" : ""}`}
        value={value}
        onChange={e => onChange(e.target.value)}
        placeholder={placeholder}
      />
      <p className="textarea-error">{error}</p>
    </section>
  );
};
